"use client"
import React from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import { usePathname } from "next/navigation";

import logo from "@/assets/images/logo.png";
import loginBG from "@/assets/images/Login-bg.png";
import loginGraphic from "@/assets/images/login-graphic.png";

export default function PublicLayout({ children }) {

  const pathname = usePathname();

  if (pathname.startsWith("/customer-form/") || pathname.startsWith("/payment/")) {
    return children;
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
      <div className="flex flex-col">
        <div className="public-header p-6 lg:p-10 2xl:p-[60px] !pb-0">
          <Image src={logo} alt="Logo ClassesCRM" width="200" height="50" />
        </div>
        <div className="public-body p-6 lg:p-10 2xl:p-[60px] flex items-center justify-center flex-auto">
          <div className="max-w-[450px] w-full mx-auto">{children}</div>
        </div>
      </div>
      <div className="hidden md:flex flex-col items-center justify-center relative p-[60px] z-[0]">
        <Image
          src={loginBG}
          alt="Login background image"
          width="960"
          height="1080"
          className="absolute top-0 left-0 w-full h-full object-cover object-center -z-[1]"
        />
        <Image
          src={loginGraphic}
          alt="Loging graphic picture"
          width="654"
          height="733"
        />
      </div>
    </div>
  );
}

PublicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
